// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/bisystem/canvas/main/cells/cell/calendar/calendar.small/calendar.small.day/calendar.small.day.scss
// module id = 4920
// module chunks = 50